module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-243.a29ef9b8.jpg";